import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import axios from "axios";
import Loader from "../../Common/Loader";
import { DASHBOARD_CLIENT_DETAIL_EQUITY } from "../../../Configuration/API_URL";
import {
  AESEncryption,
  ApiResDecrypt,
  noDataFound,
} from "../../../CommonMethhods/CommonMethods";
import { Constants } from "../../../CommonMethhods/Constants";

function PortfolioOverviewLooser() {
  const storeToken = localStorage.getItem("ssoToken");
  const [portfolioLooser, setPortfolioLooser] = useState([]);
  const [looserSymbol, setLooserSymbol] = useState();
  const [looserValue, setLooserValue] = useState();
  const [loader, setLoader] = useState(true);
  const [serverError, setServerError] = useState("");

  let clientCode = "";
  const getPortfolioLooser = async (clientCode) => {
    let payloadValue = { ClientCode: clientCode };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axios.post(
        DASHBOARD_CLIENT_DETAIL_EQUITY.PortfolioOverview_URL,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const response = ApiResDecrypt(getDetails?.data);
      const res = response.data.Loosers;
      if (res.length > 0) {
        setPortfolioLooser(res);
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
      setServerError("Something went wrong, Please try again later.");
    }
  };
  useEffect(() => {
    if (localStorage.getItem("clientCode")) {
      clientCode = localStorage.getItem("clientCode");
      getPortfolioLooser(clientCode);
    } else {
      setLoader(false);
    }
  }, []);

  const barChartData = () => {
    const symbol = [];
    const value = [];
    portfolioLooser.length > 0 &&
      portfolioLooser.map((item) => {
        symbol.push(item.Symbol);
        value.push(item.value);
      });
    setLooserSymbol(symbol);
    setLooserValue(value);
  };
  useEffect(() => {
    barChartData();
  }, [portfolioLooser]);

  const portfoliolooser = {
    credits: {
      enabled: false,
    },
    chart: {
      type: "bar",
    },
    title: {
      text: null,
    },
    xAxis: {
      categories: looserSymbol,
      title: {
        text: null,
      },
    },
    yAxis: {
      min: 0,

      // gridLineWidth:looserValue ,

      title: {
        text: null,

        align: "high",
      },

      labels: {
        // enabled: false,
        overflow: "justify",
      },
    },
    tooltip: {
      pointFormat: `{series.name}: <b>{point.y:.2f}</b>`,
    },
    plotOptions: {
      bar: {
        pointWidth: 40,
        dataLabels: {
          enabled: false,
        },
      },
    },
    legend: {
      enabled: false,
    },

    // tooltip: {
    //   enabled: false,
    // },

    series: [
      {
        name: "",
        data: looserValue,
      },
    ],
  };

  return (
    <>
      <div className="col-12 col-md-6 loosers">
        <div className="card-box graph">
          <div className="card-title">
            <h2 className="small-title">{Constants.Portfolio_Loosers}</h2>
          </div>
          {loader ? (
            <div className="loader-alignment">
              <Loader />
            </div>
          ) : (
            <div className="section-graph">
              {portfolioLooser.length > 0 ? (
                <HighchartsReact
                  highcharts={Highcharts}
                  options={portfoliolooser}
                />
              ) : serverError ===
                "Something went wrong, Please try again later." ? (
                <h4 className="no-data">{serverError}</h4>
              ) : (
                noDataFound()
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default PortfolioOverviewLooser;
